import React from 'react'
import ProgressBar from 'react-bootstrap/ProgressBar'


const StatCard = ({ label, value, maxValue, icon, iconColor, gradientFrom, gradientTo, progressVariant, delay }) => {
    const percentage = maxValue ? Math.min((value / maxValue) * 100, 100) : 0;
    return (
        <div className="col-lg-4 col-md-12" style={{marginBottom: '20px', display: 'flex'}}>
            <div style={{
                background: '#fff',
                borderRadius: '12px',
                border: '1px solid #E2E8F0',
                padding: '24px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.06)',
                transition: 'box-shadow 200ms ease, transform 200ms ease',
                position: 'relative',
                overflow: 'hidden',
                animation: 'fadeInUp 0.5s ease forwards',
                animationDelay: delay || '0s',
                opacity: 0,
                cursor: 'default',
                width: '100%',
                display: 'flex',
                flexDirection: 'column'
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.08), 0 4px 10px rgba(0,0,0,0.04)';
                e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.06)';
                e.currentTarget.style.transform = 'translateY(0)';
            }}
            >
                {/* Background accent circle */}
                <div style={{
                    position: 'absolute',
                    top: '-20px',
                    right: '-20px',
                    width: '100px',
                    height: '100px',
                    borderRadius: '50%',
                    background: `linear-gradient(135deg, ${gradientFrom}15, ${gradientTo}08)`,
                    pointerEvents: 'none'
                }}></div>

                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px'}}>
                    <div>
                        <p style={{
                            fontSize: '12px',
                            fontWeight: '500',
                            color: '#94A3B8',
                            margin: '0 0 4px',
                            textTransform: 'uppercase',
                            letterSpacing: '0.05em'
                        }}>{label}</p>
                        <div style={{display: 'flex', alignItems: 'baseline', gap: '4px'}}>
                            <h3 style={{
                                fontSize: '28px',
                                fontWeight: '700',
                                color: '#0F172A',
                                margin: 0,
                                letterSpacing: '-0.03em',
                                lineHeight: '1.2'
                            }}>{value !== undefined ? value.toLocaleString() : '—'}</h3>
                            {maxValue && (
                                <span style={{
                                    fontSize: '13px',
                                    color: '#94A3B8',
                                    fontWeight: '400'
                                }}>/ {maxValue.toLocaleString()}</span>
                            )}
                        </div>
                    </div>
                    <div style={{
                        width: '44px',
                        height: '44px',
                        borderRadius: '12px',
                        background: `linear-gradient(135deg, ${gradientFrom}, ${gradientTo})`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: `0 4px 12px ${gradientFrom}30`,
                        flexShrink: 0
                    }}>
                        <i className={icon} style={{color: '#fff', fontSize: '18px'}}></i>
                    </div>
                </div>

                {/* Progress bar */}
                <div style={{marginTop: 'auto', paddingTop: '4px'}}>
                    <div style={{
                        height: '6px',
                        background: '#F1F5F9',
                        borderRadius: '9999px',
                        overflow: 'hidden'
                    }}>
                        <div style={{
                            height: '100%',
                            width: `${percentage}%`,
                            background: `linear-gradient(90deg, ${gradientFrom}, ${gradientTo})`,
                            borderRadius: '9999px',
                            transition: 'width 0.6s cubic-bezier(0.4, 0, 0.2, 1)'
                        }}></div>
                    </div>
                    {maxValue && (
                        <p style={{
                            fontSize: '11px',
                            color: '#94A3B8',
                            margin: '6px 0 0',
                            textAlign: 'right'
                        }}>{percentage.toFixed(1)}% utilized</p>
                    )}
                </div>
            </div>
        </div>
    );
};


const MixState = (props) => {
    const { sessions, cps } = props.systemStats
    const { total, postpay } = props.accountStats
    return (
        <div className="row">
            <StatCard
                label="Sessions"
                value={sessions}
                maxValue={20000}
                icon="icon-history"
                iconColor="#10B981"
                gradientFrom="#10B981"
                gradientTo="#14B8A6"
                progressVariant="success"
                delay="0.05s"
            />
            <StatCard
                label="CPS"
                value={cps}
                maxValue={2000}
                icon="icon-phone-wave"
                iconColor="#3B82F6"
                gradientFrom="#3B82F6"
                gradientTo="#06B6D4"
                progressVariant="info"
                delay="0.1s"
            />
            <StatCard
                label="Accounts"
                value={total}
                maxValue={null}
                icon="icon-users4"
                iconColor="#F59E0B"
                gradientFrom="#F59E0B"
                gradientTo="#F97316"
                progressVariant="danger"
                delay="0.15s"
            />
        </div>
    )
}

export default MixState
